import styled from 'styled-components';

export const StyledNotFoundResult = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
`;
